import { useEffect, useState } from "react";
import CBUtils from "@cb/apricot/CBUtils";
export const useViewport = () => {
    const [viewport, setViewport] = useState(CBUtils.viewport().prefix);
    useEffect(() => {
        CBUtils.breakpoints();
        const viewportChanged = e => {
            setViewport(e.data.prefix);
        };
        document.addEventListener("apricot_breakpointChange", viewportChanged);
        return () => {
            document.removeEventListener("apricot_breakpointChange", viewportChanged);
        };
    }, []);
    return viewport;
};
//# sourceMappingURL=useViewport.js.map